// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"130":"96f21677","460":"bbfaa053","650":"3d75298c"}[chunkId] + ".css";
};